import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UIButton from '@flatfy/supernova2/src/UIKit/Button';
import { useFilterReset } from './useFilterReset';

const FlatsFiltersReset = ({ appearance, className, skipKeys }) => {
  const { handleResetClick, disabled } = useFilterReset(skipKeys);

  return (
    <div className={className}>
      <UIButton
        event={{
          category: window.eventCategory,
          action: 'filters',
          label: 'reset_click',
        }}
        size="small"
        appearance={appearance}
        onClick={handleResetClick}
        attributes={{ disabled }}
      >
        <FormattedMessage id="reset" />
      </UIButton>
    </div>
  );
};

FlatsFiltersReset.propTypes = {
  appearance: PropTypes.string,
  className: PropTypes.string,
  skipKeys: PropTypes.array,
};

export default FlatsFiltersReset;
